module.exports = __webpack_public_path__ + "img/thingstotry_md.c4beb696.png";